import React from "react";
import "./LoadingScreen.css"; // You can style this component with CSS as per your preference

const LoadingScreen = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="loading-spinner-inner"></div>
      </div>
      <div className="loading-text">Cargando...</div>
    </div>
  );
};

export default LoadingScreen;
